document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sbt-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('[data-sbt-slide]');
    var dots = carousel.querySelectorAll('[data-sbt-dot]');
    var current = 0;
    var delay = (parseInt(carousel.getAttribute('data-autoplay'), 10) || 5) * 1000;
    var timer = null;

    if (slides.length <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function start() {
      stop();
      timer = setInterval(next, delay);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    start();
  });
});
